package com.essntl.core.whatsapp.data.response

import com.essntl.features.message.domain.model.WhapiMessageModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class WhapiMessageDto(
    val id: String,
    @SerialName("from_me")
    val fromMe: Boolean,
    val type: String,
    @SerialName("chat_id")
    val chatId: String,
    val text: MessageBodyDto? = null,
    @SerialName("link_preview")
    val linkPreviewDto: LinkPreviewDto? = null,
    val timestamp: Int,
    val from: String,
    @SerialName("from_name")
    val fromName: String? = null,
    val action: MessageActionDto? = null,
    val status: String? = null,
    val source: String? = null,
) {
    @Serializable
    data class MessageBodyDto(
        val body: String,
    )

    fun toModel(): WhapiMessageModel =
        WhapiMessageModel(
            id = id,
            fromMe = fromMe,
            type = when (type) {
                "text" -> WhapiMessageModel.Type.Text
                "image" -> WhapiMessageModel.Type.Image
                "voice" -> WhapiMessageModel.Type.Voice
                "action" -> WhapiMessageModel.Type.Action
                "link_preview" -> WhapiMessageModel.Type.LinkPreview
                else -> null
            },
            chatId = chatId,
            text = text?.body,
            linkPreviewModel = linkPreviewDto?.toModel(),
            timestamp = timestamp,
            from = from,
            fromName = fromName,
            action = action?.toModel(),
            status = when (status) {
                "pending" -> WhapiMessageModel.Status.Pending
                "delivered" -> WhapiMessageModel.Status.Delivered
                "read" -> WhapiMessageModel.Status.Read
                else -> null
            },
            source = source,
        )
}
